/**
 * The heading and the card every configuration page draws.
 *
 * Departments, Managers, Projects, Roles and Substitutes each render one of these around their
 * own controls and grid. What those grids share is in AppConfigurationGrid.component.
 */
import {CircleQuestionMark} from 'lucide-react';
import {ICON_SIZE} from 'components/common/constants';
import {Tooltip} from 'components/tooltip/Tooltip';
import {HEADING_INFO_TOOLTIP_PLACE, SHARED_TOOLTIP_ID} from 'components/tooltip/AppTooltip.component';
import type {ConfigurationPageProps} from 'types/configurationPage';

/** The heading and the card every configuration page draws, around whatever that page puts in it. */
export const ConfigurationPage = ({
                                      page,
                                      titleKey,
                                      infoKey,
                                      width = 'w-75',
                                      translate,
                                      children
                                  }: ConfigurationPageProps) => {

    const tooltipId = `${page}-header-info-tooltip`;

    return (
        // the outer wrapper is what ConfigurationWrapper used to render around every configuration page
        <div>
            <div className="w-100">
                <main className="page w-100 d-flex justify-content-center align-items-start">
                    <div className={`py-16 mb-48 ${width} settings-page__container`}>
                        <h2 className="ps-4 mb-4 d-flex align-items-center">{translate(titleKey)}
                            <span className="ms-4"
                                  data-for={SHARED_TOOLTIP_ID}
                                  data-place={HEADING_INFO_TOOLTIP_PLACE}
                                  data-tip={tooltipId}>
                                <CircleQuestionMark size={ICON_SIZE.MEDIUM}/>
                            </span>
                            <Tooltip
                                id={tooltipId}
                                content={() => translate(infoKey)}
                            />
                        </h2>

                        <div className={`bg-white radius-4 p-4 setting_collapsable-main new-${page}__card`}>
                            {children}
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};
